import { KYMW1600Model } from '../kymw1600.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像情報取得要求サービス
 *
 * @export GetImageInfoDetailService
 * @class GetImageInfoDetailService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetImageInfoDetailService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof GetImageInfoDetailService
   */
  private model: KYMW1600Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof GetImageInfoDetailService
   */
  private vo: {
    imageId: string;		// 画像ID
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetImageInfoDetailService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ImageId: this.vo.imageId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetImageInfoDetailService
   */
  execute(model: any, vo: any): void {
    this.model = <KYMW1600Model> model;
    this.vo = vo;
    this.send('KYMW16GetImageInfoDetail', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageInfoDetailService
   */
  success(data: any): void {
    this.model.updateImageInfoDetail(data);
  }
}
